export default "__VITE_ASSET__dTsnICXy__"